import React from 'react'
import { Dialog } from 'primereact/dialog'
import _ from 'lodash';
import { Chip } from "primereact/chip";

import { Table, Button } from '../../../../helpers';


const StructuredMaterialSpecs = (props) => {
    const { structuredMaterials, visibleStructuredMaterialSpecs } = props

    const handleCloseMaterialSpecsConfirmModal = () => {
        props.setVisibleStructuredMaterialSpecs(false)
    }

    const getMandatoryParamsBody = (row) => {
        return row.mandatoryParams.length > 0 ?
            <div className="company-perm-roles">
                {
                    row.mandatoryParams.map((eachAttribute, index) => {
                        return eachAttribute ? (
                            <Chip
                                key={index}
                                label={eachAttribute}
                                className="mr-1 mb-1"
                            />
                        ) : "-"
                    })
                }
            </div> : "-"
    }

    const getNonMandatoryParamsBody = (row) => {
        return row.nonMandatoryParams.length > 0 ?
            <div className="company-perm-roles">
                {
                    row.nonMandatoryParams.map((eachAttribute, index) => {
                        return eachAttribute ? (
                            <Chip
                                key={index}
                                label={eachAttribute}
                                className="mr-1 mb-1"
                            />
                        ) : "-"
                    })
                }
            </div> : "-"
    }

    const specsColumns = [
        {
            header: 'Product',
            field: 'productName',
            style: { minWidth: "80px" }
        },
        {
            header: 'Variant',
            field: 'variantName',
        },
        {
            header: "Mandatory Params",
            field: "mandatoryParams",
            body: getMandatoryParamsBody,
            style: { minWidth: "200px" }
        },
        {
            header: "Non-Mandatory Params",
            field: "nonMandatoryParams",
            body: getNonMandatoryParamsBody,
            style: { minWidth: "200px" }
        },
    ]

    let flattenedStructuredMaterials = []
    if (structuredMaterials) {
        flattenedStructuredMaterials = Object.entries(structuredMaterials).flatMap(([product, variants]) => {
            return Object.entries(variants).map(([variant, { mandatoryParams, nonMandatoryParams }], index) => {

                return {
                    productName: product,
                    variantName: variant,
                    mandatoryParams,
                    nonMandatoryParams
                }
            })
        })
    }

    return (
        <Dialog header={`Structured Materials`} visible={visibleStructuredMaterialSpecs} style={{ width: '80vw', maxHeight: "80%" }} onHide={() => handleCloseMaterialSpecsConfirmModal()}>
            <div className="flex-grow-1" style={{ fontSize: "12px", textAlign: "center" }}>
                <Table 
                    tableColumns={specsColumns} 
                    data={flattenedStructuredMaterials} 
                    scrollable={true} 
                    rowGroupMode="rowspan"
                    groupRowsBy="productName"
                />
            </div>
            <div className='mt-2 flex justify-content-end'>
                <span className='text-align-left'>Please ensure all parameters are available for smooth approval flow</span>
            </div>
            <div className='mt-3 flex justify-content-end'>
                <Button label="Back" className="small-btn mr-2" style={{backgroundColor:"gray", border:"none"}} onClick={() => handleCloseMaterialSpecsConfirmModal()} />
            </div>
        </Dialog>
    )
}

export default StructuredMaterialSpecs